// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AuthNWrapper from 'components/hoc/AuthNWrapper';

import { getVodTime } from 'support/mediaTileHelper';
import { getDurationTTS } from 'support/textToSpeechHelper';
import { Brand } from 'models/propTypes/tile';
import MediaTile from './MediaTile';
import BrandedAuthTile from './BrandedAuthTile';

import styles from './VodTile.module.scss';
import HighlightsTile from './HighlightsTile';

const messages = {
  nowPlaying: {
    id: 'tile.nowPlaying',
    description: 'Text for now playing video flag',
  },
  authText: {
    id: 'tile.auth.text',
    description: 'Auth text for Media Tile',
  },
};

const VodTile = ({
  title,
  duration,
  isNowPlaying,
  authenticated,
  authTypes,
  brand,
  displayScoring,
  game,
  ...rest
}) => {
  const intl = useIntl();

  const renderTitle = () => (
    <div className={classNames('text-truncate', styles.title)}>{title}</div>
  );

  const renderMetadata = hasFocus => {
    const time = getVodTime(duration);
    if (time === '') return null;
    return (
      <React.Fragment>
        <BrandedAuthTile
          hasFocus={hasFocus}
          brand={brand}
          authenticated={authenticated}
          authTypes={authTypes}
        />

        <div className={styles.time} data-testid="metadata">
          {time}
        </div>
      </React.Fragment>
    );
  };

  const tts = [
    isNowPlaying ? intl.formatMessage(messages.nowPlaying) : null,
    !authenticated ? intl.formatMessage(messages.authText) : null,
    title,
    getDurationTTS(duration, intl),
  ]
    .filter(item => item)
    .join(', ');

  let result;
  if (displayScoring) {
    result = (
      <HighlightsTile
        renderMetadata={renderMetadata}
        size="md"
        isNowPlaying={isNowPlaying}
        game={game}
        ttsText={tts}
        {...rest}
      />
    );
  } else {
    result = (
      <MediaTile
        renderTitle={renderTitle}
        renderMetadata={renderMetadata}
        size="md"
        isNowPlaying={isNowPlaying}
        ttsText={tts}
        {...rest}
      />
    );
  }

  return result;
};

VodTile.propTypes = {
  title: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  isNowPlaying: PropTypes.bool,
  authenticated: PropTypes.bool,
  authTypes: PropTypes.arrayOf(PropTypes.string),
  brand: Brand,
  displayScoring: PropTypes.bool,
  game: PropTypes.object,
};

VodTile.defaultProps = {
  isNowPlaying: false,
  authenticated: false,
  authTypes: [],
  brand: null,
  displayScoring: false,
  game: null,
};

export default React.memo(AuthNWrapper(VodTile));
